export default "__VITE_ASSET__D_vPpbkI__"